import QueryString from "qs";

import { LOCAL_TIME_ZONE } from "constants/globalConstants.js";

import { extractSystemId } from "../utils/utils.js";

import AxiosInstance, { AxiosInstanceWithoutTimeout } from "./axiosInstance.js";

const getBaseURL = () => `/systems/${extractSystemId()}`;

export function getRequest(url, isInSystem = true, config = {}, isWithoutTimeout = false) {
  const urlApi = isInSystem ? `${getBaseURL()}${url}` : url;
  const params = config.params || {};
  config.params = { ...params, tz: LOCAL_TIME_ZONE };
  if (isWithoutTimeout) {
    return AxiosInstanceWithoutTimeout.get(urlApi, config);
  } else {
    return AxiosInstance.get(urlApi, config);
  }
}

export function postRequest(url, payload, isAdminAPI = false) {
  url = isAdminAPI ? url : `${getBaseURL()}${url}`;
  return AxiosInstance.post(url, payload).then(response => response.data || response);
}

export function putRequest(url, payload, isAdminAPI = false) {
  url = isAdminAPI ? url : `${getBaseURL()}${url}`;
  return AxiosInstance.put(url, payload).then(response => response.data || response);
}

export function deleteRequest(url, data = {}, isAdminAPI = false) {
  url = isAdminAPI ? url : `${getBaseURL()}${url}`;
  return AxiosInstance.delete(url, { data }).then(response => response.data || response);
}

export function patchRequest(url, payload, isAdminAPI = false) {
  url = isAdminAPI ? url : `${getBaseURL()}${url}`;
  return AxiosInstance.patch(url, payload).then(response => response.data || response);
}

export const paramsSerializer = params => QueryString.stringify(params, { arrayFormat: "repeat" });
